import { LANG_ABREVIATION } from "../constants/language";

import { de } from "./lang.de";
import { en } from "./lang.en";
import { fr } from "./lang.fr";
import { sp } from "./lang.sp";

export const translations = { en, fr, sp, de };
